import InitiativeService from 'src/modules/initiative/initiativeService';
import objectiveListActions from 'src/modules/objective/list/objectiveListActions';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/store';

const prefix = 'INITIATIVE_VIEW';

const initiativeViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: initiativeViewActions.FIND_STARTED,
      });

      const record = await InitiativeService.find(id);

      dispatch({
        type: initiativeViewActions.FIND_SUCCESS,
        payload: record,
      });

      dispatch(objectiveListActions.doFetch({"initiative" :id}));
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: initiativeViewActions.FIND_ERROR,
      });

      getHistory().push('/initiative');
    }
  },
};

export default initiativeViewActions;
